import { apiClient } from '../client';
import { createResourceListQueryKeys } from '../resourceListPage/queryKeys';
import type { BundleResponse, BundlesResponse, FetchBundlesParams } from './types';

export const bundlesQueryKeys = createResourceListQueryKeys<FetchBundlesParams>('bundles');

export async function getBundles(params: FetchBundlesParams): Promise<BundlesResponse> {
  const { data } = await apiClient.get<BundlesResponse>('/api/bundles', { params });
  return data;
}

export async function getBundle(id: number): Promise<BundleResponse> {
  const { data } = await apiClient.get<BundleResponse>(`/api/bundles/${id}`);
  return data;
}
